var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-module-builder',{staticClass:"dynamic-page-template",attrs:{"components":_vm.templateComponents}})}
var staticRenderFns = []

export { render, staticRenderFns }